export default __webpack_public_path__ + "static/Roboto-Thin-a732a12eb077422324070eba5dd22533.ttf";